module.exports = __webpack_public_path__ + "img/blue_081.9d46838e.png";